import { i } from "@instantdb/react";
import { StatusFind } from "@wppconnect-team/wppconnect";

type PushSubscription = {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
};

export type WhatsappConnectionEvent =
  | StatusFind
  | "pod is down"
  | "autocloseCalled"
  | "browserClose"
  | "disconnectedMobile"
  | "phoneNotConnected"
  | "qrReadError"
  | "qrReadFail"
  | "serverClose";

export const whatsappAccountStatus = {
  connected: "inChat" as const,
  reconnecting: "qrReadSuccess" as const,
  podIsDown: "pod is down" as const,
};

const _schema = i.schema({
  entities: {
    $files: i.entity({
      path: i.string().unique().indexed(),
      url: i.any(),
    }),
    $users: i.entity({
      email: i.string().unique().indexed(),
    }),
    users: i.entity({
      email: i.string().unique().indexed(),
      pushSubscriptions: i.json<Record<string, PushSubscription>>(),
      lastSeen: i.number().indexed(),
      whatsapp: i.string().optional().indexed(),
    }),
    whatsappUsers: i.entity(
      { whatsappId: i.string().unique().indexed() },
    ),
    groups: i.entity({
      whatsappId: i.string().unique().indexed(),
      name: i.string().indexed().optional().indexed(),
    }),
    chats: i.entity({
      chatId: i.string().indexed().unique(),
      network: i.string().indexed(),
    }),
    webhooks: i.entity({
      name: i.string().indexed().unique(),
      url: i.string().indexed(),
    }),
    whatsappAccounts: i.entity({
      name: i.string().indexed(),
      phoneNumber: i.string().indexed().unique(),
      webhook: i.string().indexed().optional(),
      notes: i.string().optional().indexed(),
      statusHistory: i.json<
        Array<{ status: WhatsappConnectionEvent; timestamp: number }>
      >(),
      lastEventTime: i.number().indexed().optional(),
      verificationCode: i.string().optional().unique().indexed(),
      qrIssuedAt: i.number().optional().indexed(),
      pairingCode: i.string().optional().indexed(),
      pairingCodeIssuedAt: i.number().optional().indexed(),
      isConnected: i.boolean().indexed(),
      secretToken: i.string().indexed().unique(),
    }),
    staticProxies: i.entity({
      oxylabsPort: i.number().indexed().unique(),
    }),
  },
  links: {
    whatsappAccountStaticProxies: {
      forward: {
        on: "whatsappAccounts",
        has: "one",
        label: "staticProxy",
      },
      reverse: {
        on: "staticProxies",
        has: "one",
        label: "whatsappAccount",
      },
    },
    whatsappAccountsAdmins: {
      forward: {
        on: "whatsappAccounts",
        has: "many",
        label: "admins",
        required: true,
      },
      reverse: { on: "users", has: "many", label: "whatsappAccounts" },
    },
    chatWebhooks: {
      forward: { on: "chats", label: "webhooks", has: "many" },
      reverse: { on: "webhooks", label: "chats", has: "many" },
    },
    usersGroups: {
      forward: { on: "users", has: "many", label: "groups" },
      reverse: { on: "groups", has: "many", label: "members" },
    },
  },
  rooms: {},
});

type _AppSchema = typeof _schema;
interface AppSchema extends _AppSchema {}
const schema: AppSchema = _schema;

export type { AppSchema };
export default schema;
